<template>
  <div class="real-auth-result" :class="{ check: isCheckApp, hunter: isHunterApp }">
    <img v-if="pageFrom !== '3'" :src="$setPicSize(successImg)" />
    <img v-if="pageFrom === '3'" :src="$setPicSize(failImg)" />
    <div class="result-info">
      <header>{{ info }}</header>
      <!-- <span v-if="pageFrom === '2' & appV !== 'zzhunter'">请至PC端继续完成入驻流程</span> -->
    </div>
    <div class="operation-area">
      <div class="quit highlight" @click="quit"><span>关闭</span></div>
    </div>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import setPicSize from '@zz-app/setPicSize'
import { lego } from '@zz-common/lego'
import { queryParams, isCheckApp, isHunterApp } from '../../lib/utils'

const query = queryParams()
// pageFrom 1:人工审核 2：不扫脸得成功页面
export default {
  name: 'CommitResult',
  data() {
    return {
      from: query.from || this.$route.query.from || '1',
      pageFrom: query.pageFrom || this.$route.query.pageFrom || '1',
      isCheckApp,
      isHunterApp,
      successImg: 'f9436be4-ddfb-4f7b-8047-f0ae914e714c.png',
      failImg: '2980c180-8a0e-48e5-9ffb-ec7ad3ec4766.png',
      appV: native.client
    }
  },
  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    info() {
      if (this.pageFrom === '1') return '您的申请已提交成功，请耐心等待' //人工审核提交成功页
      if (this.pageFrom === '2') return '恭喜您认证成功' // 无需扫脸成功页
      if (this.pageFrom === '3') return '您的申请提交失败，请耐心等待' //兜底页
      if (this.pageFrom === '4') return '身份证更新成功' //认证过期 对应文案
    }
  },
  methods: {
    adapterOS() {
      if (isCheckApp) {
        this.successImg = require('./images/check_auth_success.png')
        this.failImg = require('./images/check_auth_fail.png')
      }
      if (isHunterApp) {
        this.successImg = require('./images/hunt_auth_success.png')
        this.failImg = require('./images/hunt_auth_fail.png')
      }
    },
    $setPicSize(url) {
      return setPicSize(url, 500, 500)
    },
    quit() {
      native.close()
    }
  },
  created() {
    native.setTitle({
      title: '商业实人认证'
    })
    lego.send({
      pagetype: 'ZZUP_BUSREALAUTH_COMMITRESULT',
      actiontype: 'PAGE_SHOW',
      backup: {
        sourceCode: this.from
      }
    })
    this.adapterOS()
  }
}
</script>

<style lang="less" scoped>
  @import './CommitResult.less';
</style>
